export const TIME_FORMAT = 'h:mm aa';

export const DATE_FORMAT = 'M/d/yyyy';

export const DATETIME_FORMAT = 'h:mm aa • M/d/yyyy';
export const INTAKE_V2_DATETIME_FORMAT = 'h:mm aa M/d/yyyy';
export const INTAKE_V2_DATETIME_FORMAT_FRIENDLY = '00:00:00 AM:PM MM/DD/YYYY';

export const DATETIME_LONG_FORMAT = 'MMMM d, yyyy h:mm aa';
